import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import AdminLogin from './pages/AdminLogin';
import StudentLogin from './pages/StudentLogin';
import AdminDashboard from './pages/AdminDashboard';
import StudentDashboard from './pages/StudentDashboard';
import { authAPI } from './services/api';

function App() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkAuth = useCallback(async () => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const response = await authAPI.getMe();
                setUser(response.data);
            } catch (error) {
                localStorage.removeItem('token');
            }
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        checkAuth();
    }, [checkAuth]);

    const handleLogin = (userData, token) => {
        localStorage.setItem('token', token);
        setUser(userData);
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        setUser(null);
    };

    if (loading) {
        return (
            <div className="loading-screen">
                <div className="spinner"></div>
                <p>Loading...</p>
            </div>
        );
    }

    return (
        <Router>
            <div className="app">
                <ToastContainer position="top-right" autoClose={3000} />
                <Routes>
                    {/* Public routes */}
                    <Route
                        path="/admin/login"
                        element={
                            user && user.role === 'admin' ? (
                                <Navigate to="/admin/dashboard" />
                            ) : (
                                <AdminLogin onLogin={handleLogin} />
                            )
                        }
                    />
                    <Route
                        path="/login"
                        element={
                            user && user.role === 'student' ? (
                                <Navigate to="/dashboard" />
                            ) : (
                                <StudentLogin onLogin={handleLogin} />
                            )
                        }
                    />

                    {/* Protected routes */}
                    <Route
                        path="/admin/dashboard"
                        element={
                            user && user.role === 'admin' ? (
                                <AdminDashboard user={user} onLogout={handleLogout} />
                            ) : (
                                <Navigate to="/admin/login" />
                            )
                        }
                    />
                    <Route
                        path="/dashboard"
                        element={
                            user && user.role === 'student' ? (
                                <StudentDashboard user={user} onLogout={handleLogout} />
                            ) : (
                                <Navigate to="/login" />
                            )
                        }
                    />

                    {/* Default redirects */}
                    <Route
                        path="/"
                        element={
                            user ? (
                                user.role === 'admin' ? (
                                    <Navigate to="/admin/dashboard" />
                                ) : (
                                    <Navigate to="/dashboard" />
                                )
                            ) : (
                                <Navigate to="/login" />
                            )
                        }
                    />
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
